/**
 * Money typed on a phone. A Slovak or German keypad offers "," as the decimal
 * key and an English one ".", so both are read as the separator. A native
 * number input would silently drop whichever one the browser locale disagrees
 * with, which is why amounts are typed into a text field and parsed here.
 */

const UNSIGNED_DRAFT = /^\d*[.,]?\d*$/;
const SIGNED_DRAFT = /^-?\d*[.,]?\d*$/;

/** True while `text` could still become a number: "12," and "-" are mid-typing. */
export function isDecimalDraft(text, { allowNegative = false } = {}) {
  return (allowNegative ? SIGNED_DRAFT : UNSIGNED_DRAFT).test(text);
}

/** The number `text` spells, or null when it does not spell one yet. */
export function parseDecimal(text) {
  if (!/\d/.test(text)) return null;
  const value = Number(text.replace(",", "."));
  return Number.isFinite(value) ? value : null;
}

/** The text an input shows for a stored value. */
export function formatDecimalDraft(value) {
  return value == null ? "" : String(value);
}
